'use strict';

angular.module('adelementAdminApp').controller('ExcludedFieldDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExcludedField',
        function($scope, $stateParams, $uibModalInstance, entity, ExcludedField) {

        $scope.excludedField = entity;
        $scope.load = function(id) {
            ExcludedField.get({id : id}, function(result) {
                $scope.excludedField = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('adelementAdminApp:excludedFieldUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.excludedField.id != null) {
                ExcludedField.update($scope.excludedField, onSaveSuccess, onSaveError);
            } else {
                ExcludedField.save($scope.excludedField, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);
